module.exports = __webpack_public_path__ + "media/icons/key-f-dark-2ec8c6a5.svg";